<template>
  <v-menu offset-y :close-on-content-click="false" :min-width="400">
    <template v-slot:activator="{ on }">
      <v-btn class="mx-2" icon v-on="on">
        <v-icon>mdi-tune</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-text-field
          label="Peso Máximo (minutos)"
          v-model="opts.maxIntensity"
          hint="Se vazio, estica automaticamente. Útil para remover outliers."
        />

        <v-text-field
          label="Raio (pixels)"
          v-model="opts.radius"
          hint="Se o modo dissipação estiver OFF, use de 0.0001 para baixo."
        />

        <v-switch
          label="Modo Dissipação"
          v-model="opts.dissipating"
          hint="Se ON, o raio varia de acordo com o zoom."
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    opts: { required: true }
  }
}
</script>

<style></style>
